import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const August = () => {
    return (
        <Fragment>{SkipDays(6, 1, [23, 24, 25, 26, 27, 28, 29, 30, 31], true)}</Fragment>  
    )
}